import { clearTrackingEvents, setTrackingEvents } from '../../services/trackingService';
import './contact.component.scss';

export default function ContactView() {
    return {
        oncreate: () => setTrackingEvents('a.target-link', 'contact'),
        onremove: () => clearTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="headline">
                <h2>Contact Void Hunter</h2>
            </div>
            <div class="content contact-content">
                <div class="content__col content__col--contact box-border-rough">
                    <div class="contact-item">
                        <div class="contact-item--title">
                            Email
                        </div>
                        <div class="contact-item--action">
                            intothevoid ~at~ voidhunter.com
                        </div>
                    </div>
                    <div class="contact-item contact-item-social">
                        <div class="contact-item--title">
                            Social
                        </div>
                        <div class="contact-item--action">
                            <a class="instagram-icon target-link" data-type="social" data-target="instagram" href="https://www.instagram.com/voidhunterofficial/" target="_blank">
                                <img src="/assets/ig-icon-black.png" alt="Instagram icon" />
                                <p>Instagram</p>
                            </a>
                            <a class="facebook-icon target-link" data-type="social" data-target="facebook" href="https://www.facebook.com/voidhunterofficial/" target="_blank">
                                <img src="/assets/fb-icon-black.png" alt="Facebook icon" />
                                <p>Facebook</p>
                            </a>
                        </div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-item--title">
                            Bandsintown
                        </div>
                        <div class="contact-item--action">
                            <iframe src="https://bandsintown.com/artist/id_15560541/track_button?actor_type=ARTIST&background_color=rgba(0,0,0,1)&hover_color=rgba(0,0,0,0.8)&font=Roboto&bitIcon=show&text=FOLLOW&text_color=rgba(231,225,212,1)&locale=en&display_tracker_count=hide&size=large"
                                title="newsletter-widget"
                                height="35"
                                width="150"
                                scrolling="no"
                                frameborder="0"
                                style="border:none; overflow:hidden;"
                                allowtransparency="true">
                            </iframe>
                        </div>
                    </div>
                    <div class="contact-item contact-item-bandsintown-form">
                        <iframe src="https://bandsintown.com/artist/15560541/email_signup_form?headerTextColor=rgba(0,0,0,1)&backgroundColor=rgba(231,225,212,0)&ctaBackgroundColor=rgba(100,100,100,1)&title=MAILING LIST&headerTextStyle=normal&headerText=Get the latest updates. All glam, no spam.&font=Helvetica&ctaIcon=show&ctaBorderRadius=4px&ctaBorderWidth=0px&ctaBorderColor=rgba(221,44,0,1)&ctaFontColor=rgba(0,0,0,1)&alignment=center&emailInputField=show&ctaLabel=Subscribe&layout=wide&locale=en&appId=vh-web"
                            title="newsletter-widget">
                        </iframe>
                    </div>
                </div>
            </div>
        </>),
    };
}
